import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../auth/auth.service';
import { Pair } from '../../../interfaces/pair';
import { PairService } from '../../../services/pair.service';
import { NotifyService } from '../../../common/notify/notify.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { ParticipantService } from '../../../services/participant.service';
import { Approval, ApprovalStatus } from '../../../interfaces/approval';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-close-dialog',
  imports: [MatDialogModule, MatFormFieldModule, CommonModule, ReactiveFormsModule, FormsModule, MatOptionModule, MatSelectModule, MatButtonModule, MatInputModule],
  providers: [NotifyService],
  templateUrl: './close-dialog.component.html',
  styleUrl: './close-dialog.component.scss'
})
export class closeDialogComponent {
  constructor(
    private readonly authService: AuthService,
    private readonly participantService: ParticipantService,
    private readonly ref: MatDialogRef<closeDialogComponent>,
    private readonly notify: NotifyService,
    @Inject(MAT_DIALOG_DATA) readonly approval: Approval
  ) {}

  //Used for when an error occurs, it won't show that the approval is denied
  approvalCopy: Approval | null = null;
  selectedReason: string | undefined = undefined;
  otherReason: string | undefined = undefined;

  async close() {
    this.approvalCopy = { ...this.approval, status: ApprovalStatus.DENIED, closedReason: this.otherReason };

    this.participantService.updateApproval(this.approvalCopy).subscribe({
      next: () => {
        this.approval.status = ApprovalStatus.DENIED;
        this.approval.closedReason = this.otherReason;
        this.approval.dateProcessed = new Date().toISOString();
        this.notify.withAutodismiss(`Denied approval request for recipient ${this.approvalCopy?.recipient?.firstName}`);
        this.ref.close(true);
      },
      error: (err) => {
        console.error(err);
        this.notify.withAutodismiss('Failed to deny request. Please try again.');
      }
    });
  }

  cancel() {
    this.ref.close(false);
  }
}
